module.exports = __webpack_public_path__ + "static/media/menu-2.6049fe9b.svg";